import { Component, OnInit, signal } from '@angular/core';
import User from '../../models/user';
import { UserService } from '../../services/user-service';
import { BackButtonComponent } from '../back-button-component/back-button-component';
import { LoadingComponent } from '../loading-component/loading-component';

@Component({
  selector: 'app-users-component',
  imports: [BackButtonComponent, LoadingComponent],
  templateUrl: './users-component.html',
  styleUrl: './users-component.css',
})
export class UsersComponent implements OnInit {
  users = signal<User[]>([]);
  isLoadingUsers = signal(true);
  loadUsersError = '';
  
  constructor(private userService: UserService) { }

  ngOnInit(): void {
    this.getUsers();
  }

  getUsers(): void {
    this.isLoadingUsers.set(true);
    this.loadUsersError = '';

    this.userService.getUsers().subscribe({
      next: (data: User[]) => {
        this.users.set(data);
        this.isLoadingUsers.set(false);
      },
      error: (error) => {
        this.isLoadingUsers.set(false);
        this.loadUsersError = 'Could not load the guild registry from the backend.';
        console.error('Error fetching users:', error);
      }
    });
  }

}
